module.exports = __webpack_public_path__ + "assets/images/pages/job/job-header.png?0d9d0e6c";